export const vehicles = [
  {
    id: 1,
    year: 2020,
    make: 'Toyota',
    model: 'Camry',
    trim: 'XSE V6',
    vin: '4T1B11HK5LU123456',
    mileage: 32500,
    transmission: 'Automatic',
    drivetrain: 'FWD',
    fuelType: 'Gasoline',
    engine: '3.5L V6',
    exteriorColor: 'Midnight Black Metallic',
    interiorColor: 'Black Leather',
    doors: 4,
    seats: 5,
    mpgCity: 22,
    mpgHighway: 32,
    condition: 'Excellent',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 24500,
    location: 'Portland, OR',
    postedDate: '2 days ago',
    description: 'Immaculate 2020 Toyota Camry XSE with the powerful V6 engine. This vehicle has been meticulously maintained with all service records available. Features include premium leather interior, navigation system, and advanced safety features. Perfect for someone looking for a reliable and sporty sedan.',
    images: [
      'https://public.readdy.ai/ai/img_res/c776cd98dc57435d3e1ecaa1e85984f0.jpg',
      'https://readdy.ai/api/search-image?query=2020%20toyota%20camry%20xse%20black%20leather%20interior%20dashboard%20view%20showing%20modern%20infotainment%20system%20premium%20materials%20steering%20wheel%20and%20center%20console%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh1img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2020%20toyota%20camry%20xse%20rear%20three%20quarter%20view%20midnight%20black%20metallic%20paint%20showing%20sporty%20rear%20design%20led%20taillights%20and%20dual%20exhaust%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh1img3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2020%20toyota%20camry%20xse%20v6%20engine%20bay%20showing%20clean%20maintained%2035%20liter%20engine%20with%20professional%20lighting%20and%20simple%20neutral%20background%20automotive%20detail%20photography&width=800&height=500&seq=veh1img4&orientation=landscape'
    ],
    features: [
      'Navigation System',
      'Leather Seats',
      'Heated Front Seats',
      'Sunroof',
      'Backup Camera',
      'Blind Spot Monitoring',
      'Apple CarPlay & Android Auto',
      'Adaptive Cruise Control',
      'Lane Departure Warning',
      'Automatic Emergency Braking',
      'Premium Audio System',
      'Dual-Zone Climate Control'
    ],
    owner: {
      name: 'Michael Chen',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20man%20in%20his%20thirties%20smiling%20friendly%20portrait%20photo%20with%20clean%20simple%20light%20background%20business%20casual%20attire&width=200&height=200&seq=owner1&orientation=squarish',
      rating: 4.9,
      totalSwaps: 12,
      memberSince: 'Jan 2022',
      responseTime: 'Within 2 hours',
      verified: true
    }
  },
  {
    id: 2,
    year: 2019,
    make: 'Honda',
    model: 'Civic',
    trim: 'Sport Touring',
    vin: '2HGFC2F59KH234567',
    mileage: 45800,
    transmission: 'CVT Automatic',
    drivetrain: 'FWD',
    fuelType: 'Gasoline',
    engine: '1.5L Turbo I4',
    exteriorColor: 'Rallye Red',
    interiorColor: 'Black Cloth',
    doors: 4,
    seats: 5,
    mpgCity: 29,
    mpgHighway: 37,
    condition: 'Very Good',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 19800,
    location: 'Seattle, WA',
    postedDate: '5 days ago',
    description: 'Well-maintained 2019 Honda Civic Sport Touring with excellent fuel economy and sporty handling. This vehicle comes with a complete service history and has never been in an accident. The turbocharged engine provides great performance while maintaining impressive fuel efficiency.',
    images: [
      'https://readdy.ai/api/search-image?query=vibrant%20rallye%20red%202019%20honda%20civic%20sport%20touring%20sedan%20parked%20in%20contemporary%20setting%20with%20clean%20simple%20light%20gray%20background%20professional%20automotive%20photography%20front%20angle%20view%20showing%20sporty%20aggressive%20front%20grille%20and%20led%20headlights&width=800&height=500&seq=veh2img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2019%20honda%20civic%20sport%20touring%20black%20cloth%20interior%20showing%20modern%20dashboard%20digital%20instrument%20cluster%20touchscreen%20infotainment%20and%20sport%20seats%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh2img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2019%20honda%20civic%20sport%20touring%20rallye%20red%20side%20profile%20view%20showing%20sleek%20coupe%20like%20design%20sporty%20wheels%20and%20aerodynamic%20body%20lines%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh2img3&orientation=landscape'
    ],
    features: [
      'Turbocharged Engine',
      'Honda Sensing Safety Suite',
      'Apple CarPlay & Android Auto',
      'Dual-Zone Climate Control',
      'Heated Front Seats',
      'Power Sunroof',
      'LED Headlights',
      'Adaptive Cruise Control',
      'Lane Keeping Assist',
      'Collision Mitigation Braking',
      'Premium Audio System',
      'Remote Start'
    ],
    owner: {
      name: 'Sarah Johnson',
      avatar: 'https://readdy.ai/api/search-image?query=friendly%20professional%20woman%20in%20her%20late%20twenties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20business%20attire&width=200&height=200&seq=owner2&orientation=squarish',
      rating: 4.8,
      totalSwaps: 8,
      memberSince: 'Mar 2022',
      responseTime: 'Within 3 hours',
      verified: true
    }
  },
  {
    id: 3,
    year: 2021,
    make: 'Ford',
    model: 'F-150',
    trim: 'XLT SuperCrew 4x4',
    vin: '1FTEW1EP5MFA34567',
    mileage: 28300,
    transmission: '10-Speed Automatic',
    drivetrain: '4WD',
    fuelType: 'Gasoline',
    engine: '3.5L EcoBoost V6',
    exteriorColor: 'Agate Black',
    interiorColor: 'Medium Earth Gray Cloth',
    doors: 4,
    seats: 5,
    mpgCity: 18,
    mpgHighway: 24,
    condition: 'Excellent',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 42500,
    location: 'Boise, ID',
    postedDate: '1 week ago',
    description: 'Powerful and capable 2021 Ford F-150 XLT with the legendary EcoBoost engine. This truck has been used primarily for highway driving and is in exceptional condition. Features include 4x4 capability, towing package, and advanced technology features. Perfect for work or adventure.',
    images: [
      'https://readdy.ai/api/search-image?query=rugged%20agate%20black%202021%20ford%20f150%20xlt%20supercrew%20pickup%20truck%20parked%20in%20outdoor%20setting%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20bold%20chrome%20grille%20and%20muscular%20stance&width=800&height=500&seq=veh3img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2021%20ford%20f150%20xlt%20interior%20cabin%20showing%20spacious%20supercrew%20seating%20modern%20sync%20infotainment%20system%20steering%20wheel%20controls%20and%20comfortable%20cloth%20seats%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh3img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2021%20ford%20f150%20xlt%20truck%20bed%20view%20showing%20spacious%20cargo%20area%20bed%20liner%20and%20tie%20down%20points%20with%20clean%20simple%20background%20professional%20automotive%20detail%20photography&width=800&height=500&seq=veh3img3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2021%20ford%20f150%20xlt%20side%20profile%20view%20agate%20black%20showing%20supercrew%20cab%20chrome%20wheels%20and%204x4%20capability%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh3img4&orientation=landscape'
    ],
    features: [
      'EcoBoost Engine',
      '4x4 Off-Road Package',
      'Towing Package',
      'Trailer Backup Assist',
      'SYNC 3 Infotainment',
      'Apple CarPlay & Android Auto',
      'Rear View Camera',
      'Power-Adjustable Seats',
      'Remote Start',
      'Cruise Control',
      'Bed Liner',
      'Running Boards'
    ],
    owner: {
      name: 'David Martinez',
      avatar: 'https://readdy.ai/api/search-image?query=confident%20hispanic%20man%20in%20his%20forties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20outdoor%20attire&width=200&height=200&seq=owner3&orientation=squarish',
      rating: 5.0,
      totalSwaps: 15,
      memberSince: 'Sep 2021',
      responseTime: 'Within 1 hour',
      verified: true
    }
  },
  {
    id: 4,
    year: 2018,
    make: 'Toyota',
    model: 'RAV4',
    trim: 'Limited AWD',
    vin: '2T3BFREV8JW456789',
    mileage: 52400,
    transmission: 'Automatic',
    drivetrain: 'AWD',
    fuelType: 'Gasoline',
    engine: '2.5L I4',
    exteriorColor: 'Magnetic Gray Metallic',
    interiorColor: 'Black SofTex',
    doors: 4,
    seats: 5,
    mpgCity: 23,
    mpgHighway: 30,
    condition: 'Good',
    titleStatus: 'Clean Title',
    accidents: 1,
    owners: 2,
    estimatedValue: 22900,
    location: 'Eugene, OR',
    postedDate: '3 days ago',
    description: 'Reliable 2018 Toyota RAV4 Limited with all-wheel drive capability. This SUV has been regularly serviced and maintained. One minor accident reported with full repair documentation available. Great family vehicle with plenty of cargo space and excellent safety ratings.',
    images: [
      'https://readdy.ai/api/search-image?query=sleek%20magnetic%20gray%20metallic%202018%20toyota%20rav4%20limited%20suv%20parked%20in%20modern%20urban%20environment%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20refined%20design%20and%20premium%20wheels&width=800&height=500&seq=veh4img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2018%20toyota%20rav4%20limited%20black%20softex%20interior%20showing%20premium%20dashboard%20touchscreen%20navigation%20leather%20like%20seats%20and%20modern%20amenities%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh4img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2018%20toyota%20rav4%20limited%20rear%20cargo%20area%20showing%20spacious%20trunk%20space%20folding%20seats%20and%20practical%20storage%20solutions%20with%20clean%20simple%20background%20professional%20automotive%20detail%20photography&width=800&height=500&seq=veh4img3&orientation=landscape'
    ],
    features: [
      'All-Wheel Drive',
      'Navigation System',
      'SofTex Leather Seats',
      'Heated Front Seats',
      'Power Liftgate',
      'Sunroof',
      'Blind Spot Monitor',
      'Rear Cross Traffic Alert',
      'Backup Camera',
      'Dual-Zone Climate Control',
      'Premium Audio',
      'Roof Rails'
    ],
    owner: {
      name: 'Emily Thompson',
      avatar: 'https://readdy.ai/api/search-image?query=warm%20friendly%20woman%20in%20her%20mid%20thirties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20comfortable%20attire&width=200&height=200&seq=owner4&orientation=squarish',
      rating: 4.7,
      totalSwaps: 6,
      memberSince: 'Jun 2022',
      responseTime: 'Within 4 hours',
      verified: true
    }
  },
  {
    id: 5,
    year: 2022,
    make: 'Tesla',
    model: 'Model 3',
    trim: 'Long Range AWD',
    vin: '5YJ3E1EB5NF123456',
    mileage: 18500,
    transmission: 'Single-Speed Automatic',
    drivetrain: 'AWD',
    fuelType: 'Electric',
    engine: 'Dual Motor Electric',
    exteriorColor: 'Pearl White Multi-Coat',
    interiorColor: 'Black Premium Interior',
    doors: 4,
    seats: 5,
    mpgCity: 0,
    mpgHighway: 0,
    condition: 'Excellent',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 38900,
    location: 'San Francisco, CA',
    postedDate: '1 day ago',
    description: 'Stunning 2022 Tesla Model 3 Long Range with dual motor all-wheel drive. This electric vehicle offers incredible performance, cutting-edge technology, and zero emissions. Features Autopilot, premium connectivity, and over 350 miles of range. Includes home charging equipment.',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20pearl%20white%202022%20tesla%20model%203%20long%20range%20electric%20sedan%20parked%20in%20modern%20minimalist%20setting%20with%20clean%20simple%20light%20gray%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20sleek%20aerodynamic%20design%20and%20distinctive%20led%20headlights&width=800&height=500&seq=veh5img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2022%20tesla%20model%203%20minimalist%20black%20premium%20interior%20showing%20large%20horizontal%20touchscreen%20display%20vegan%20leather%20seats%20glass%20roof%20and%20modern%20dashboard%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh5img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2022%20tesla%20model%203%20pearl%20white%20rear%20three%20quarter%20view%20showing%20smooth%20aerodynamic%20design%20led%20taillights%20and%20sporty%20stance%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh5img3&orientation=landscape'
    ],
    features: [
      'Autopilot',
      'Dual Motor AWD',
      '350+ Mile Range',
      'Premium Connectivity',
      'Glass Roof',
      'Premium Audio System',
      '15-inch Touchscreen',
      'Over-the-Air Updates',
      'Supercharger Access',
      'Heated Seats (Front & Rear)',
      'Power Trunk',
      'Sentry Mode'
    ],
    owner: {
      name: 'Alex Rivera',
      avatar: 'https://readdy.ai/api/search-image?query=tech%20savvy%20professional%20person%20in%20their%20early%20thirties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20modern%20casual%20attire&width=200&height=200&seq=owner5&orientation=squarish',
      rating: 4.9,
      totalSwaps: 10,
      memberSince: 'Feb 2022',
      responseTime: 'Within 1 hour',
      verified: true
    }
  },
  {
    id: 6,
    year: 2017,
    make: 'Chevrolet',
    model: 'Silverado 1500',
    trim: 'LT Crew Cab 4WD',
    vin: '1GCVKREC8HZ234567',
    mileage: 68200,
    transmission: '6-Speed Automatic',
    drivetrain: '4WD',
    fuelType: 'Gasoline',
    engine: '5.3L V8',
    exteriorColor: 'Summit White',
    interiorColor: 'Jet Black Cloth',
    doors: 4,
    seats: 6,
    mpgCity: 16,
    mpgHighway: 22,
    condition: 'Good',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 2,
    estimatedValue: 28500,
    location: 'Denver, CO',
    postedDate: '4 days ago',
    description: 'Dependable 2017 Chevrolet Silverado 1500 with powerful V8 engine and 4WD capability. This truck has been well-maintained and is ready for work or play. Features include towing package, spray-in bedliner, and plenty of interior space. Great for hauling and outdoor adventures.',
    images: [
      'https://readdy.ai/api/search-image?query=robust%20summit%20white%202017%20chevrolet%20silverado%201500%20lt%20crew%20cab%20pickup%20truck%20parked%20outdoors%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20bold%20chrome%20grille%20and%20strong%20stance&width=800&height=500&seq=veh6img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2017%20chevrolet%20silverado%201500%20lt%20jet%20black%20cloth%20interior%20showing%20spacious%20crew%20cab%20seating%20mylink%20touchscreen%20system%20and%20comfortable%20bench%20seats%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh6img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2017%20chevrolet%20silverado%201500%20truck%20bed%20with%20spray%20in%20bedliner%20showing%20durable%20cargo%20area%20and%20tie%20down%20points%20with%20clean%20simple%20background%20professional%20automotive%20detail%20photography&width=800&height=500&seq=veh6img3&orientation=landscape'
    ],
    features: [
      '5.3L V8 Engine',
      '4WD System',
      'Towing Package',
      'Spray-In Bedliner',
      'MyLink Infotainment',
      'Backup Camera',
      'Bluetooth Connectivity',
      'Cruise Control',
      'Power Windows & Locks',
      'Air Conditioning',
      'Trailer Brake Controller',
      'Chrome Wheels'
    ],
    owner: {
      name: 'Robert Wilson',
      avatar: 'https://readdy.ai/api/search-image?query=rugged%20outdoorsy%20man%20in%20his%20late%20forties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20work%20attire&width=200&height=200&seq=owner6&orientation=squarish',
      rating: 4.6,
      totalSwaps: 9,
      memberSince: 'Aug 2021',
      responseTime: 'Within 5 hours',
      verified: true
    }
  },
  {
    id: 7,
    year: 2023,
    make: 'Mazda',
    model: 'CX-5',
    trim: 'Signature AWD',
    vin: '7JMZMAEM5P1234567',
    mileage: 12400,
    transmission: '6-Speed Automatic',
    drivetrain: 'AWD',
    fuelType: 'Gasoline',
    engine: '2.5L Turbo I4',
    exteriorColor: 'Soul Red Crystal Metallic',
    interiorColor: 'Caturra Brown Nappa Leather',
    doors: 4,
    seats: 5,
    mpgCity: 22,
    mpgHighway: 27,
    condition: 'Excellent',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 36800,
    location: 'Portland, OR',
    postedDate: '2 days ago',
    description: 'Luxurious 2023 Mazda CX-5 Signature with premium Nappa leather interior and turbocharged engine. This SUV combines elegant design with impressive performance. Features include Bose audio, 360-degree camera, and advanced safety technology. Like new condition with full warranty remaining.',
    images: [
      'https://readdy.ai/api/search-image?query=stunning%20soul%20red%20crystal%20metallic%202023%20mazda%20cx5%20signature%20suv%20parked%20in%20upscale%20modern%20setting%20with%20clean%20simple%20light%20gray%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20elegant%20kodo%20design%20and%20premium%20wheels&width=800&height=500&seq=veh7img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2023%20mazda%20cx5%20signature%20luxurious%20caturra%20brown%20nappa%20leather%20interior%20showing%20premium%20dashboard%20materials%20large%20touchscreen%20wood%20trim%20and%20comfortable%20seats%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh7img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2023%20mazda%20cx5%20signature%20soul%20red%20rear%20three%20quarter%20view%20showing%20sophisticated%20design%20led%20taillights%20and%20sporty%20profile%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh7img3&orientation=landscape'
    ],
    features: [
      'Turbocharged Engine',
      'Nappa Leather Interior',
      'Bose Premium Audio',
      '360-Degree Camera',
      'Head-Up Display',
      'Adaptive LED Headlights',
      'Heated & Ventilated Seats',
      'Power Liftgate',
      'Wireless Charging',
      'Traffic Jam Assist',
      'Panoramic Sunroof',
      'Apple CarPlay & Android Auto'
    ],
    owner: {
      name: 'Jennifer Lee',
      avatar: 'https://readdy.ai/api/search-image?query=sophisticated%20professional%20woman%20in%20her%20early%20forties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20elegant%20business%20attire&width=200&height=200&seq=owner7&orientation=squarish',
      rating: 5.0,
      totalSwaps: 7,
      memberSince: 'Jan 2023',
      responseTime: 'Within 2 hours',
      verified: true
    }
  },
  {
    id: 8,
    year: 2016,
    make: 'Nissan',
    model: 'Altima',
    trim: '2.5 SV',
    vin: '1N4AL3AP8GC345678',
    mileage: 78500,
    transmission: 'CVT Automatic',
    drivetrain: 'FWD',
    fuelType: 'Gasoline',
    engine: '2.5L I4',
    exteriorColor: 'Gun Metallic',
    interiorColor: 'Charcoal Cloth',
    doors: 4,
    seats: 5,
    mpgCity: 27,
    mpgHighway: 38,
    condition: 'Good',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 3,
    estimatedValue: 12900,
    location: 'Sacramento, CA',
    postedDate: '1 week ago',
    description: 'Affordable and reliable 2016 Nissan Altima with excellent fuel economy. This sedan has been regularly maintained and runs great. Perfect for daily commuting with comfortable seating and good cargo space. Recent tires and brakes. Great value for the price.',
    images: [
      'https://readdy.ai/api/search-image?query=practical%20gun%20metallic%202016%20nissan%20altima%20sv%20sedan%20parked%20in%20everyday%20setting%20with%20clean%20simple%20light%20gray%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20modern%20design%20and%20alloy%20wheels&width=800&height=500&seq=veh8img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2016%20nissan%20altima%20sv%20charcoal%20cloth%20interior%20showing%20comfortable%20dashboard%20touchscreen%20display%20and%20practical%20seating%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh8img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2016%20nissan%20altima%20sv%20side%20profile%20view%20gun%20metallic%20showing%20sleek%20sedan%20design%20and%20aerodynamic%20lines%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh8img3&orientation=landscape'
    ],
    features: [
      'Backup Camera',
      'Bluetooth Connectivity',
      'Push Button Start',
      'Dual-Zone Climate Control',
      'Power Driver Seat',
      'Alloy Wheels',
      'Cruise Control',
      'USB Ports',
      'Keyless Entry',
      'Power Windows & Locks',
      'Tilt & Telescoping Steering',
      'Split-Folding Rear Seat'
    ],
    owner: {
      name: 'Marcus Brown',
      avatar: 'https://readdy.ai/api/search-image?query=friendly%20african%20american%20man%20in%20his%20late%20twenties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20everyday%20attire&width=200&height=200&seq=owner8&orientation=squarish',
      rating: 4.5,
      totalSwaps: 5,
      memberSince: 'Nov 2022',
      responseTime: 'Within 6 hours',
      verified: true
    }
  },
  {
    id: 9,
    year: 2021,
    make: 'Jeep',
    model: 'Wrangler',
    trim: 'Rubicon 4xe',
    vin: '1C4JJXP68MW456789',
    mileage: 24600,
    transmission: '8-Speed Automatic',
    drivetrain: '4WD',
    fuelType: 'Plug-in Hybrid',
    engine: '2.0L Turbo I4 + Electric',
    exteriorColor: 'Hydro Blue Pearl',
    interiorColor: 'Black Leather',
    doors: 4,
    seats: 5,
    mpgCity: 49,
    mpgHighway: 47,
    condition: 'Excellent',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 48900,
    location: 'Salt Lake City, UT',
    postedDate: '3 days ago',
    description: 'Adventure-ready 2021 Jeep Wrangler Rubicon 4xe plug-in hybrid with incredible off-road capability and eco-friendly electric range. This Wrangler combines legendary Jeep capability with modern efficiency. Features include removable top, upgraded suspension, and premium interior. Perfect for outdoor enthusiasts.',
    images: [
      'https://readdy.ai/api/search-image?query=adventurous%20hydro%20blue%20pearl%202021%20jeep%20wrangler%20rubicon%204xe%20plug%20in%20hybrid%20suv%20parked%20in%20rugged%20outdoor%20setting%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20iconic%20seven%20slot%20grille%20and%20off%20road%20capability&width=800&height=500&seq=veh9img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2021%20jeep%20wrangler%20rubicon%204xe%20black%20leather%20interior%20showing%20modern%20uconnect%20touchscreen%20rugged%20design%20comfortable%20seats%20and%20premium%20materials%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh9img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2021%20jeep%20wrangler%20rubicon%204xe%20hydro%20blue%20side%20view%20showing%20removable%20top%20off%20road%20tires%20rock%20rails%20and%20muscular%20stance%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh9img3&orientation=landscape'
    ],
    features: [
      'Plug-in Hybrid System',
      'Rubicon Off-Road Package',
      'Removable Top & Doors',
      'Rock-Trac 4WD System',
      'Electronic Sway Bar Disconnect',
      'Uconnect Touchscreen',
      'Alpine Premium Audio',
      'LED Lighting Package',
      'Heated Seats & Steering Wheel',
      'Remote Start',
      'Trail Rated Badge',
      'All-Terrain Tires'
    ],
    owner: {
      name: 'Jessica Parker',
      avatar: 'https://readdy.ai/api/search-image?query=adventurous%20athletic%20woman%20in%20her%20early%20thirties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20outdoor%20casual%20attire&width=200&height=200&seq=owner9&orientation=squarish',
      rating: 4.9,
      totalSwaps: 11,
      memberSince: 'Apr 2022',
      responseTime: 'Within 2 hours',
      verified: true
    }
  },
  {
    id: 10,
    year: 2020,
    make: 'BMW',
    model: '3 Series',
    trim: '330i xDrive',
    vin: 'WBA5R1C05LFJ56789',
    mileage: 35800,
    transmission: '8-Speed Automatic',
    drivetrain: 'AWD',
    fuelType: 'Gasoline',
    engine: '2.0L Turbo I4',
    exteriorColor: 'Alpine White',
    interiorColor: 'Black Vernasca Leather',
    doors: 4,
    seats: 5,
    mpgCity: 26,
    mpgHighway: 36,
    condition: 'Excellent',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 32800,
    location: 'Seattle, WA',
    postedDate: '4 days ago',
    description: 'Sophisticated 2020 BMW 3 Series 330i with xDrive all-wheel drive and premium features. This luxury sport sedan delivers exceptional performance and comfort. Features include premium sound system, advanced driver assistance, and elegant interior. Meticulously maintained with full service history.',
    images: [
      'https://readdy.ai/api/search-image?query=elegant%20alpine%20white%202020%20bmw%203%20series%20330i%20xdrive%20luxury%20sport%20sedan%20parked%20in%20upscale%20urban%20setting%20with%20clean%20simple%20light%20gray%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20iconic%20kidney%20grille%20and%20sporty%20design&width=800&height=500&seq=veh10img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2020%20bmw%203%20series%20330i%20black%20vernasca%20leather%20interior%20showing%20premium%20dashboard%20idrive%20system%20digital%20instrument%20cluster%20and%20sport%20seats%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh10img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2020%20bmw%203%20series%20330i%20alpine%20white%20rear%20three%20quarter%20view%20showing%20sleek%20sedan%20profile%20led%20taillights%20and%20sporty%20stance%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh10img3&orientation=landscape'
    ],
    features: [
      'xDrive All-Wheel Drive',
      'Turbocharged Engine',
      'Vernasca Leather Seats',
      'Harman Kardon Audio',
      'iDrive 7.0 System',
      'Wireless Charging',
      'Heated Seats',
      'Power Sunroof',
      'Active Driving Assistant',
      'Parking Assistant',
      'LED Headlights',
      'Apple CarPlay'
    ],
    owner: {
      name: 'Christopher Davis',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20businessman%20in%20his%20late%20thirties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20business%20casual%20attire&width=200&height=200&seq=owner10&orientation=squarish',
      rating: 4.8,
      totalSwaps: 9,
      memberSince: 'May 2022',
      responseTime: 'Within 3 hours',
      verified: true
    }
  },
  {
    id: 11,
    year: 2019,
    make: 'Subaru',
    model: 'Outback',
    trim: '2.5i Limited',
    vin: '4S4BSANC5K3456789',
    mileage: 48900,
    transmission: 'CVT Automatic',
    drivetrain: 'AWD',
    fuelType: 'Gasoline',
    engine: '2.5L H4',
    exteriorColor: 'Crimson Red Pearl',
    interiorColor: 'Ivory Leather',
    doors: 4,
    seats: 5,
    mpgCity: 26,
    mpgHighway: 33,
    condition: 'Very Good',
    titleStatus: 'Clean Title',
    accidents: 0,
    owners: 1,
    estimatedValue: 24200,
    location: 'Portland, OR',
    postedDate: '5 days ago',
    description: 'Versatile 2019 Subaru Outback with legendary all-wheel drive and spacious interior. This wagon combines SUV capability with car-like handling. Perfect for outdoor adventures and daily driving. Features include EyeSight safety system, leather interior, and excellent ground clearance.',
    images: [
      'https://readdy.ai/api/search-image?query=versatile%20crimson%20red%20pearl%202019%20subaru%20outback%20limited%20wagon%20parked%20in%20scenic%20outdoor%20setting%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20rugged%20design%20and%20raised%20ground%20clearance&width=800&height=500&seq=veh11img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2019%20subaru%20outback%20limited%20ivory%20leather%20interior%20showing%20spacious%20cabin%20large%20touchscreen%20eyesight%20system%20and%20comfortable%20seating%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh11img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2019%20subaru%20outback%20crimson%20red%20rear%20cargo%20area%20showing%20generous%20storage%20space%20folding%20seats%20and%20practical%20design%20with%20clean%20simple%20background%20professional%20automotive%20detail%20photography&width=800&height=500&seq=veh11img3&orientation=landscape'
    ],
    features: [
      'Symmetrical AWD',
      'EyeSight Safety System',
      'Leather Seats',
      'Power Liftgate',
      'Heated Front & Rear Seats',
      'Harman Kardon Audio',
      'Navigation System',
      'Adaptive Cruise Control',
      'Lane Keep Assist',
      'Blind Spot Detection',
      'Roof Rails',
      'X-Mode Off-Road System'
    ],
    owner: {
      name: 'Amanda Foster',
      avatar: 'https://readdy.ai/api/search-image?query=outdoorsy%20woman%20in%20her%20mid%20thirties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20outdoor%20attire&width=200&height=200&seq=owner11&orientation=squarish',
      rating: 4.7,
      totalSwaps: 8,
      memberSince: 'Jul 2022',
      responseTime: 'Within 4 hours',
      verified: true
    }
  },
  {
    id: 12,
    year: 2015,
    make: 'Volkswagen',
    model: 'Jetta',
    trim: 'SE',
    vin: '3VW2B7AJ5FM567890',
    mileage: 92300,
    transmission: '6-Speed Automatic',
    drivetrain: 'FWD',
    fuelType: 'Gasoline',
    engine: '1.8L Turbo I4',
    exteriorColor: 'Pure White',
    interiorColor: 'Titan Black Cloth',
    doors: 4,
    seats: 5,
    mpgCity: 25,
    mpgHighway: 36,
    condition: 'Fair',
    titleStatus: 'Clean Title',
    accidents: 1,
    owners: 3,
    estimatedValue: 8900,
    location: 'Spokane, WA',
    postedDate: '1 week ago',
    description: 'Budget-friendly 2015 Volkswagen Jetta with turbocharged engine and good fuel economy. This sedan has higher mileage but runs well and has been maintained. One minor accident reported. Great starter car or commuter vehicle at an affordable price point.',
    images: [
      'https://readdy.ai/api/search-image?query=clean%20pure%20white%202015%20volkswagen%20jetta%20se%20sedan%20parked%20in%20simple%20setting%20with%20clean%20simple%20light%20gray%20background%20professional%20automotive%20photography%20front%20three%20quarter%20view%20showing%20classic%20vw%20design&width=800&height=500&seq=veh12img1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2015%20volkswagen%20jetta%20se%20titan%20black%20cloth%20interior%20showing%20practical%20dashboard%20touchscreen%20and%20comfortable%20seating%20with%20clean%20simple%20neutral%20background%20professional%20automotive%20interior%20photography&width=800&height=500&seq=veh12img2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=2015%20volkswagen%20jetta%20se%20pure%20white%20side%20profile%20view%20showing%20sedan%20proportions%20and%20clean%20lines%20with%20clean%20simple%20light%20background%20professional%20automotive%20photography&width=800&height=500&seq=veh12img3&orientation=landscape'
    ],
    features: [
      'Turbocharged Engine',
      'Touchscreen Display',
      'Bluetooth Connectivity',
      'Backup Camera',
      'Cruise Control',
      'Power Windows & Locks',
      'Air Conditioning',
      'USB Port',
      'Keyless Entry',
      'Tilt Steering Wheel',
      'Split-Folding Rear Seat',
      'Alloy Wheels'
    ],
    owner: {
      name: 'Tyler Anderson',
      avatar: 'https://readdy.ai/api/search-image?query=young%20man%20in%20his%20mid%20twenties%20smiling%20portrait%20photo%20with%20clean%20simple%20light%20background%20casual%20everyday%20attire&width=200&height=200&seq=owner12&orientation=squarish',
      rating: 4.3,
      totalSwaps: 4,
      memberSince: 'Oct 2022',
      responseTime: 'Within 8 hours',
      verified: true
    }
  }
];
